import React from 'react';
import { Form } from 'antd';
import { ActionPlan } from '@/components/Settings/DataExtraction/ExtractionType/Hierarchy/Steps/Reports/ActionPlan';
import { useDataExtractionReport } from '@/context/DataExtractionReport';

const { useWatch } = Form;

export function ActionPlanSection(): JSX.Element {
	const selectedReports = useWatch(['reports', 'selected_reports']);
	const { dataExtractionReport } = useDataExtractionReport();
	const reportType = dataExtractionReport?.custom_report?.report_type;
	const formattedName = dataExtractionReport?.custom_report?.name;

	return <ActionPlan reportIds={selectedReports} reportType={reportType} formattedName={formattedName} />;
}
